module.exports = __webpack_public_path__ + "img/location.e13c694a.png";